'use strict';
module.exports = !!(typeof window !== 'undefined' && window.document && window.document.createElement);


//////////////////
// WEBPACK FOOTER
// ./~/react-overlays/~/dom-helpers/util/inDOM.js
// module id = 1042
// module chunks = 0